import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import {
  ClosableModalWithErrorResponseModel
} from '../../../shared/components/base/closable-modal-with-error-response-model';

import {
  CreatePbaModalPayload,
  CreatePbaPayload,
  CreatePbaErrorResponse,
  PrimaryLegalEntity
} from '../../../shared/models';

import { ModalService } from '../../../shared/modules/modal';
import { NotificationService, PbasService } from '../../../shared/services';

@Component({
  selector: 'create-pba-modal',
  templateUrl: './create-pba-modal.component.html',
})
export class CreatePbaModalComponent
  extends ClosableModalWithErrorResponseModel<CreatePbaErrorResponse>
  implements OnInit, OnDestroy {
  data: CreatePbaModalPayload;
  pba: CreatePbaPayload = new CreatePbaPayload();
  primaryEntities: PrimaryLegalEntity[] = [];
  selectedEntityId: number;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _pbaService: PbasService
  ) {
    super(notificationService, modalService);
  }

  ngOnInit(): void {
    this.listenForErrorMessages();
    this.getPrimaryEntities();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => { subscription.unsubscribe(); });
  }

  getPrimaryEntities(): void {
    this._pbaService.getListOfPrimaryEntitiesForCreate(this.data.study).subscribe(({ data }) => {
      this.primaryEntities = data;
    });
  }

  create(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.pba.study = { studyId: this.data.study.studyId };
    this.pba.method = 1; // Will be changed when Pba Method Enum is introduced
    this.pba.primaryLegalEntity = { entityId: this.selectedEntityId ? +this.selectedEntityId : null };
    this._pbaService.createPba(this.pba).subscribe(() => {
      this.success();
      this.closeAllModals();
    });
  }
}
